import { render, staticRenderFns } from "./PageNotice.vue?vue&type=template&id=f36dedde&scoped=true&"
import script from "./PageNotice.vue?vue&type=script&lang=js&"
export * from "./PageNotice.vue?vue&type=script&lang=js&"
import style0 from "./PageNotice.vue?vue&type=style&index=0&id=f36dedde&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f36dedde",
  null
  
)

export default component.exports